import styled from "styled-components";

import * as Code from "ds/Code";
import * as Dropdown from "ds/Dropdown";

export const Layout = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: max-content 1fr;
  gap: 16px;

  box-sizing: border-box;
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`;

export const CodeBlock = styled(Code.Block)`
  display: grid;
`;

export const DropdownContent = styled(Dropdown.Content)`
  min-width: unset;
`;
